{
  "unsubscribe_title": "E-Mails abbestellen",
  "unsubscribe_message": "Schade, dass sie sich abmelden wollen.",
  "unsubscribe": "Abbestellen",
  "cancel": "Abbrechen",
  "passwordResetSuccess": "Dein Password wurde erfolgreich geändert.",
  "passwordResetError": "Leider gab es ein Problem",
  "passwordResetExpired": "Dieser Link ist ungültig oder abgelaufen. Bitte fordere ein neues Passwort-Reset an.",
  "passwordResetTitle": "Neues Passwort festlegen",
  "new_password": "Neues Passwort",
  "confirm_password": "Neues Passwort bestätigen",
  "save": "Speichern",
  "error": "Leider gab es ein Problem",
  "unsubscribeSuccess": "Die Aktion war erfolgreich",
  "emailChangeLoading": "E-Mail Änderung lädt...",
  "emailChangeSuccess": "Die E-Mail wurde erfolgreich geändert.",
  "emailChangeError": "Leider gab es ein Problem bei der Änderung der E-Mail",
  "home": {
    "tagline": "Über 1 Million Hundebesitzer trainieren mit Hundeo",
    "subline": "Von echten Hundetrainern empfohlen",
    "appStorePrefix": "Laden im",
    "playStorePrefix": "Jetzt bei",
    "qrHint": "App auf dem Smartphone öffnen",
    "qrCaption": "Scanne den Code mit deiner Kamera",
    "socialProof": "5.000+ 5-Sterne-Bewertungen",
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "language": "Sprache",
    "openWebsite": "Zur Website",
    "openInApp": "Hundeo App öffnen",
    "openInAppHint": "Du wirst zu deiner App weitergeleitet",
    "openInAppButton": "Öffnen",
    "promoRedirectTitle": "Dein Angebot wird geöffnet …",
    "promoRedirectButton": "Weiter zum Angebot"
  }
}
